import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  const [contentRef, contentInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [imageRef, imageInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const [buttonRef, buttonInView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="flex-grow flex items-center justify-center py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="md:flex md:items-center md:gap-12">
            <motion.div 
              ref={imageRef}
              className="md:w-1/2 mb-8 md:mb-0"
              initial={{ opacity: 0, x: -50 }}
              animate={imageInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
              transition={{ duration: 0.8 }}
            >
              <img 
                src="/homestay/outdoor3.jpg" 
                alt="Riverside Scene" 
                className="rounded-lg shadow-lg w-full h-auto object-cover transform transition-transform duration-500 hover:scale-105" 
              />
            </motion.div>
            
            <motion.div 
              ref={contentRef}
              className="md:w-1/2 text-center md:text-left"
              initial={{ opacity: 0, x: 50 }}
              animate={contentInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
              transition={{ duration: 0.8 }}
            >
              <h1 className="text-6xl font-bold text-blue-900">404</h1>
              <h2 className="text-3xl font-bold text-blue-800 mt-4">Oops! You've drifted off course</h2>
              <p className="mt-6 text-lg text-gray-600">
                The page you're looking for seems to have floated away. 
                Let's get you back to the riverside retreat.
              </p>
              
              <motion.div 
                ref={buttonRef}
                className="mt-8"
                initial={{ opacity: 0, y: 20 }}
                animate={buttonInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <Link to="/">
                  <motion.button
                    className="bg-blue-800 hover:bg-blue-700 text-white font-bold px-6 py-3 rounded-lg text-lg transition-colors duration-200 mr-4"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Return Home
                  </motion.button>
                </Link>
                
                <Link to="/#booking-form">
                  <motion.button
                    className="bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold px-6 py-3 rounded-lg text-lg transition-colors duration-200"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Book Now
                  </motion.button>
                </Link>
              </motion.div>
            </motion.div>
          </div>
          
          <motion.div 
            className="mt-16 text-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <h3 className="text-xl font-medium text-blue-900">Looking for something specific?</h3>
            <p className="mt-2 text-gray-600">
              Call us directly at <a href="tel:+919400949078" className="text-blue-600 hover:underline font-medium">+91 9400949078</a> for assistance.
            </p>
          </motion.div>
        </div>
      </div>
      
      <motion.footer 
        className="bg-blue-800 text-white py-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5, delay: 0.6 }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p>© {new Date().getFullYear()} Riverside Bliss Villa. All rights reserved.</p>
        </div>
      </motion.footer>
    </div>
  );
};

export default NotFoundPage;